import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/circle_24.svg.ts
import { svg } from "lit";
var circle24Svg = svg`
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6719_4440)">
        <path d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
        <clipPath id="clip0_6719_4440">
            <rect width="24" height="24"/>
        </clipPath>
    </defs>
</svg>



`;
export {
  circle24Svg
};
//# sourceMappingURL=circle_24.svg-NZRHXSXM.js.map
